<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="handleClose"
    :width="breakpoints.lgAndUp ? '30%' : '70%'"
    top="20vh"
    custom-class="custom-scrollable"
  >
    <div class="font-normal pb-2">
      <div class="text-xl mt-4 py-4 font-bold text-black-2 flex justify-center">
        Asset Transfer
      </div>
      <div class="font-normal mb-4">
        <el-form
          label-position="top"
          :model="assetWithdrawalForm"
          ref="assetWithdrawalForm"
          :rules="rules"
          label-width="80px"
          size="normal"
        >
          <el-form-item label="Select Network" prop="network">
            <el-select
              class="w-full"
              v-model="assetWithdrawalForm.network"
              placeholder="Select Network"
            >
              <el-option
                v-for="item in network"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Currency" prop="assetType">
            <el-select
              class="w-full"
              v-model="assetWithdrawalForm.assetType"
              placeholder="Select Currency"
            >
              <el-option
                v-for="item in coinCurrency"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Wallet Address" prop="walletAddress">
            <el-input
              class="w-full"
              v-model.trim="assetWithdrawalForm.walletAddress"
              placeholder="Enter Wallet Address"
            >
            </el-input>
          </el-form-item>
          <o-button @click="validateForm('assetWithdrawalForm')">Done</o-button>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { ASSET_TYPE, USDC_NETWORKS } from '@/utils/constants.js'
import { ValidateWallet, ValidateSingleSpace } from '@/utils/helpers.js'
import breakpoints from '@/utils/breakpoints.js'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints,
      coinCurrency: ASSET_TYPE,
      network: USDC_NETWORKS,
      assetWithdrawalForm: {
        network: '',
        assetType: '',
        walletAddress: ''
      },
      rules: {
        network: [
          {
            required: true,
            message: 'Please select network',
            trigger: 'blur'
          }
        ],
        assetType: [
          {
            required: true,
            message: 'Asset type is required',
            trigger: 'blur'
          }
        ],
        walletAddress: [
          {
            required: true,
            message: 'Please enter a valid wallet address',
            trigger: 'change'
          },
          {
            validator: this.validateWalletAddress,
            trigger: ['change']
          },
          {
            validator: ValidateSingleSpace,
            trigger: ['change']
          }
        ]
      }
    }
  },
  methods: {
    validateForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$emit('closeDialog')
          this.$emit('storeAssetInfo', { ...this.assetWithdrawalForm })
          this.$emit('verifyUser')
        } else {
          this.$notify.error({
            title: 'Invalid Details',
            message: 'Please fill the required details',
            position: 'top-right'
          })
        }
      })
    },
    handleClose () {
      this.$emit('closeDialog')
    },
    validateWalletAddress (rule, value, callback) {
      const validator = this.network.find(
        (network) => network.value === this.assetWithdrawalForm.network
      ).validator
      const network = this.network.find(
        (network) => network.value === this.assetWithdrawalForm.network
      ).shortName

      const isValid = ValidateWallet(value, network, validator)
      if (!isValid) {
        callback(new Error("Invalid, Wallet address doesn't exist on network"))
      } else {
        callback()
      }
    }
  },
  components: {}
}
</script>

<style scoped>
>>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
>>> .el-form-item__label {
  margin-bottom: 3px;
  line-height: 16px;
}

>>> .el-input__inner {
  border-radius: 8px;
  border-color: #c7c8d2;
  height: 45px;
  font-weight: 400 !important;
  font-size: 14px !important;
}
>>> .el-dialog {
  border-radius: 30px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
